"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssociationType = exports.DomainEventType = void 0;
var DomainEventType;
(function (DomainEventType) {
    DomainEventType["SECTION"] = "SECTION";
    DomainEventType["CATALOGUE"] = "CATALOGUE";
    DomainEventType["CATALOGUE_STORE_ASSOC"] = "CATALOGUE_STORE_ASSOC";
    DomainEventType["CATALOGUE_VENUE_ASSOC"] = "CATALOGUE_VENUE_ASSOC";
    DomainEventType["CATALOGUE_ITEM"] = "CATALOGUE_ITEM";
    // MENU SCHEDULE
    DomainEventType["MENU_SCHEDULE"] = "MENU_SCHEDULE";
    DomainEventType["PAGE"] = "PAGE";
    DomainEventType["PAGE_ITEM"] = "PAGE_ITEM";
    DomainEventType["PRODUCT_GROUP"] = "PRODUCT_GROUP";
    DomainEventType["CATEGORY"] = "CATEGORY";
    DomainEventType["CATEGORY_ITEM"] = "CATEGORY_ITEM";
    DomainEventType["COURSE"] = "COURSE";
    DomainEventType["COURSE_ITEM"] = "COURSE_ITEM";
    // PRODUCT SECTION
    DomainEventType["PRODUCT"] = "PRODUCT";
    DomainEventType["VARIANT"] = "VARIANT";
    DomainEventType["PRODUCT_STORE_ASSOC"] = "PRODUCT_STORE_ASSOC";
    DomainEventType["PRODUCT_SALES_CHANNEL_ASSOC"] = "PRODUCT_SALES_CHANNEL_ASSOC";
    DomainEventType["PRODUCT_MODIFIER_GROUP_ASSOC"] = "PRODUCT_MODIFIER_GROUP_ASSOC";
    DomainEventType["STOCK_PRICING"] = "STOCK_PRICING";
    //Product & Variant group
    DomainEventType["PRODUCT_VARIANT_GROUP_ASSOC"] = "PRODUCT_VARIANT_GROUP_ASSOC";
    // MODIFIERS
    DomainEventType["MODIFIER_GROUP"] = "MODIFIER_GROUP";
    DomainEventType["MODIFIER"] = "MODIFIER";
    // PRICING
    DomainEventType["PRICING_GROUP"] = "PRICING_GROUP";
    DomainEventType["MODIFIER_PRICING"] = "MODIFIER_PRICING";
    //
    DomainEventType["SHIFT"] = "SHIFT";
})(DomainEventType = exports.DomainEventType || (exports.DomainEventType = {}));
var AssociationType;
(function (AssociationType) {
    AssociationType["PRICING_GROUP"] = "pricingGroup";
    AssociationType["TAG"] = "tag";
    AssociationType["STORE"] = "store";
    AssociationType["SALES_CHANNEL"] = "salesChannel";
    AssociationType["CATEGORY"] = "category";
    AssociationType["MODIFIER_GROUP"] = "modifierGroup";
    AssociationType["COURSE"] = "course";
    AssociationType["PRODUCT_GROUP"] = "productGroup";
    AssociationType["STOCK_PRICING"] = "stockPricing";
    AssociationType["VARIANT_TEMPLATE"] = "variantTemplate";
})(AssociationType = exports.AssociationType || (exports.AssociationType = {}));
//# sourceMappingURL=associationEventTypes.js.map